import { DSQuickLinks } from '../../../cimsPage/instances/ds'
import { QuickLinks } from '../../common'

const quickLinks = QuickLinks({
  page: DSQuickLinks,
  create: 'BABB5D9B-F792-49E9-B3BA-9F0A8ABED819',
  view: '3BFF6C6B-921C-4EB1-A3CA-0C0DF66003F5',
  edit: '50C451E7-00CB-458B-9F1F-3FEAB125A5C8',
  removeRestore: '695957EC-B349-4F6B-9A2C-1AC17CEEF9CD',
})

export const CreateDesignSubmittalQuickLink = quickLinks.Create
export const ViewDesignSubmittalQuickLink = quickLinks.View
export const EditDesignSubmittalQuickLink = quickLinks.Edit
export const RemoveRestoreDesignSubmittalQuickLink = quickLinks.RemoveRestore

export type DSQuickLinkPermission =
  | typeof CreateDesignSubmittalQuickLink
  | typeof ViewDesignSubmittalQuickLink
  | typeof EditDesignSubmittalQuickLink
  | typeof RemoveRestoreDesignSubmittalQuickLink
